import { Observable } from 'rxjs';

export abstract class SetCartCalculationModeAdapter {
  abstract setCartCalculationMode(
    cartCalculationMode: boolean,
    cartId: string
  ): Observable<any>;
}
